import jwtDecode from 'jwt-decode';
import moment from 'moment';

export default function tokenIsValid (token) {
	let decoded;

	try {
		decoded = jwtDecode(token);
	} catch (e) {
		return false;
	}
	return moment(decoded.exp).isAfter(moment().unix());
}
